<!--  -->
<template>
 <div class="travelServe culturalcommodity">
   <banner/>
   <crumbs />
   <div class="container1">
       <div class="labelBox">
          <type-screen modelType="culturalcommodity" :menu-id="menuId" @typeObj="selectType"/>
        </div>
        <div class="dataList">
          <div class="dataItem" v-for="(item) in dataList" :key="item.id" @click="gotodetail(item.id)">
            <img :src="getImage(item.image)" alt="">
            <div class="title">
              {{item.name}}
            </div>
            <span class="type" v-if="item.servearr !== undefined && item.servearr[0] !== undefined">{{item.servearr[0]}}</span>
          </div>
             <nodata v-show="nodataflag"/>

        </div>
        <el-pagination
            @current-change="handleCurrentChange"
            :page-size="params.pageSize"
            :pager-count="5"
            layout="prev, pager, next"
            :total=total
            class="elpagination"
          >   </el-pagination>

   </div>
 </div>
</template>

<script>
import nodata from '@/components/nodata/index'
import banner from '@/components/banner/index'
import crumbs from '@/components/crumbs/index'
import { getTypeList } from '@/api/typescreen/index'
import typeScreen from '@/components/typescreen/index'
import {getculturalcommodityList} from '@/api/culturalcommodity/index'
export default {
  name: 'culturalcommodity',
  components: {
    banner, crumbs, typeScreen, nodata
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      menuId: '',
      params: {
        page: 1,
        limit: 6,
        menuId: '',
        subjectType: null,
        productType: null,
        customTypeId: null
      },
      total: 0,
      dataList: [],
      nodataflag: false,
      typeParams: {
        menuId: '',
        dictParentCode: 'culturalCommodityProductType,culturalCommodityProductType'
      }
    }
  },
  created () {
    this.menuId = this.$route.query.columnId
    this.params.menuId = this.$route.query.columnId
    this.typeParams.menuId = this.$route.query.columnId
    this.getculturalcommodityList()
  },
  methods: {

    defaultamout (list) {
      getTypeList(this.typeParams).then(val1 => {
        let productTypes = val1.data.data.dictType.culturalCommodityProductType.list
        list.forEach((val, index) => {
          let servearr = []
          let serviceBinkList = val.productType

          productTypes.forEach((demo, i) => {
            if (serviceBinkList === demo.dictCode) {
              servearr.push(demo.dictName)
            }
          })

          val.servearr = servearr
        })
      })
    },

    getculturalcommodityList () {
      getculturalcommodityList(this.params).then(res => {
        console.log(res)
        if (res.data.status === 200) {
          this.total = res.data.data.total
          if (this.total === 0) {
            this.nodataflag = true
          } else {
            this.nodataflag = false
          }
          this.defaultamout(res.data.data.rows)
          this.dataList = res.data.data.rows
        }
      })
    },
    selectType (obj) {
      this.params.subjectType = obj.subjectType
      this.params.productType = obj.productType
      this.params.customTypeId = obj.customTypeId
      this.dataList = []
      this.getculturalcommodityList()
    },
    getImage (val) {
      if (val === undefined || val === '') {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getculturalcommodityList()
    },
    gotodetail (id) {
      this.$router.push({
        path: 'culturalcommoditydetail',
        query: {
          id,
          columnId: this.menuId
        }
      })
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import "../../assets/common/scss/travleServes.scss";
@import '../../assets/common/scss/culturalcommodity.scss';
.elpagination{
 text-align: center;

}

.container1{
      padding-bottom: 300px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/culturalcommodity/list.vue